// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules

import './casestudies.scss';

const MODULE_NAME = 'chatbotsCasestudies';
angular

    .module(MODULE_NAME, [
    ])

    .directive('appChatbotsCasestudies', () => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./casestudies.html'),
        link: ($scope, element, attrs) => {},
      };
    })

    .controller('ChatbotsCasestudiesCtrl', function() {
    // ---------------------------------------------------------------------- //
    // Methods

      /**
     * onInit
     */
      function onInit() {
      }

      // ---------------------------------------------------------------------- //
      // Private

      // ---------------------------------------------------------------------- //
      // Public
      const ctrl = this;
      ctrl.list = [
        {
          id: 'armani-smartwatch',
          title: 'Giorgio Armani',
          subtitle: 'Smart Watch Global Launch Events',
          icon: 'armani',
        },
        {
          id: 'john-lewis-storybook',
          title: 'John Lewis',
          subtitle: 'Interactive Storybook',
          icon: 'john-lewis',
        },
        {
          id: 'storycastle',
          title: 'HarperCollins',
          subtitle: 'StoryCastle',
          icon: 'harpercollins',
        },
        {
          id: 'smallfoot',
          title: 'Warner Bros',
          subtitle: 'Smallfoot',
          icon: 'warner-bros',
        },
      ];

      // ---------------------------------------------------------------------- //
      // Watches/events

      // ---------------------------------------------------------------------- //
      onInit();
    });

export default MODULE_NAME;
